import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from '~/util/msalConfig';
import { Loading } from '~/shared/Loading';

export function RedirectToLoginPage() {
	const { instance, accounts, inProgress } = useMsal();
	const navigate = useNavigate();

	useEffect(() => {
		if (inProgress !== InteractionStatus.None) return;

		// Already authenticated (e.g. landed here after a completed login) —
		// send the user on instead of sitting on the loading screen forever.
		if (accounts.length > 0) {
			const redirectUri = sessionStorage.getItem('redirectUri');
			sessionStorage.removeItem('redirectUri');
			navigate(redirectUri ?? '/', { replace: true });
			return;
		}

		instance.loginRedirect(loginRequest).catch(error => {
			console.error('Login redirect error:', error);
		});
	}, [instance, accounts, inProgress, navigate]);

	return <Loading message="Redirecting to login page..." />;
}
